import React, { useEffect, useRef, Fragment } from 'react';
import { translate } from '../Services/translation';

const Navigation = ({ links = [], contentLink = null, showExtraLinks = true, extraLinks = null }) => {
    const menuRef = useRef(null);

    function toggleMenu() {
        const isMenuOpen = menuRef.current.classList.toggle('navbar__menu--show');
        if (isMenuOpen) {
            document.body.classList.add('no-scroll');
            menuRef.current.focus();
        } else {
            document.body.classList.remove('no-scroll');
        }
    }
    
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            menuRef.current.classList.remove('navbar__menu--show');
            document.body.classList.remove('no-scroll');
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.classList.remove('no-scroll');
        };
    }, []);

    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const showSublistBelow = contentLink && contentLink.showAsSubmenu;
    const showSublistBelowClass = contentLink && contentLink.showAsSubmenu ? 'show-sublist-below' : '';
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;
    const hasChildren = link => (link.links || []).length > 0;

    return (
        <Fragment>
            {!contentLink &&
                <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}>
                    <span className="navbar__icon title">{ translate('navbar.title') }</span>
                </a>
            }
            {contentLink && !showSublistBelow &&
                <Fragment>
                    {hasChildren(contentLink) ? (
                        <div className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`} onClick={toggleMenu} >
                            {contentLink.attributes && contentLink.attributes.imageUrl && <div className="navbar__link-image-container" style={{ backgroundImage: `url(${contentLink.attributes.imageUrl})` }}></div>}
                            <span className="navbar__link-text">{contentLink.name}</span>
                        </div>
                    ) :
                        (
                            <a className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`}
                                href={contentLink.url || '#'} >
                                {contentLink.attributes && contentLink.attributes.imageUrl && <div className="navbar__link-image-container" style={{ backgroundImage: `url(${contentLink.attributes.imageUrl})` }}></div>}
                                <div className="navbar__link-item-container" dangerouslySetInnerHTML={{ __html: contentLink.name }}></div>
                            </a>
                        )
                    }
                </Fragment>
            }
            {links.length > 0 && (
                <ul className={`navbar__menu ${showSublistBelowClass}`} ref={menuRef} test={links.length}>
                    {!showSublistBelow ? (
                        <NavbarMenuHeader contentLink={contentLink} toggleMenu={toggleMenu} />
                    ) :
                        (
                            <li className="navbar__sublist-heading">{contentLink.name}</li>
                        )
                    }
                    <ul className="navbar__item-list">
                    {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                        <li className="navbar__item" key={!link.name ? `${new Date().getTime()}-${i}` : `${link.name}-${i}`}>
                            <Navigation links={link.links} contentLink={link} bottomLink={false} />
                        </li>

                    )}
                    </ul>
                    {/* Mobile extraLinks */}
                    {showExtraLinks && extraLinks &&  <li className="navbar__extralinks show-for-small-only">
                        {extraLinks.length > 0 && extraLinks.map((extraLink, i) =>
                            <a href={extraLink.href} key={i} className={`navbar__extralink`}>
                                <i className={`${extraLink.attributes.class}__icon`}></i>
                                <div className="navbar__extralink-title">{extraLink.text}</div>
                            </a>
                        )}
                    </li>}

                </ul>
            )
            }

        </Fragment>
    )
}

const NavbarMenuHeader = ({ contentLink, toggleMenu }) => (
    <div className="navbar__menu-header">
        {!contentLink ? (
            <Fragment>
                <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}></span>
                <span className="navbar__title">{translate('general.meny')}</span>
            </Fragment>
        ) : (
                <Fragment>
                    <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                    <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                </Fragment>
            )}
    </div>
)

export default Navigation;
